import axios from "axios";
import { gsap } from "gsap";
import { TextPlugin } from "gsap/TextPlugin";
import React, { Suspense, useEffect, useRef, useState } from "react";
import { Helmet } from "react-helmet";
import Layout from "../components/Layout";
import Particle from "../components/Particle";
import Socialicons from "../components/Socialicons";
import Spinner from "../components/Spinner";

gsap.registerPlugin(TextPlugin);

function Home({ lightMode }) {
  const [information, setInformation] = useState("");
  const h1Ref = useRef(null);
  const h2Ref = useRef(null);
  const pRef = useRef(null);
  const iconsRef = useRef(null);

  useEffect(() => {
    axios.get("/api/information").then((response) => {
      setInformation(response.data);
    });
  }, []);

  useEffect(() => {
    try {
      gsap.from(h1Ref.current, { opacity: 0, y: -20, duration: 0.8, ease: "power2.out" });
    } catch (e) {}
  }, []);

  useEffect(() => {
    if (!information.name) return;
    const fullText = `Welcome, I'm ${information.name}`;
    if (h2Ref.current) h2Ref.current.textContent = fullText;
    try {
      const tl = gsap.timeline({ delay: 0.3 });
      tl.to(h2Ref.current, {
        duration: fullText.length * 0.055,
        text: { value: fullText },
        ease: "none",
      })
        .from(pRef.current, { opacity: 0, y: 15, duration: 0.7, ease: "power2.out" }, "-=0.1")
        .from(iconsRef.current, { opacity: 0, y: 10, duration: 0.5, ease: "power2.out" }, "-=0.3");
      return () => tl.kill();
    } catch (e) {}
  }, [information.name]);

  return (
    <Layout>
      <Helmet>
        <title>calee.me</title>
        <meta name="description" content="Carrie Lee, Designmaster" />
      </Helmet>
      <Suspense fallback={<Spinner />}>
        <div className="mi-home-area mi-padding-section">
          <Particle lightMode={lightMode} />
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-lg-10 col-12">
                <div className="mi-home-content">
                  <h1 ref={h1Ref}>
                    <span className="color-theme">calee.me</span>
                  </h1>
                  <h2 ref={h2Ref}></h2>
                  <p ref={pRef}>
                    {information.aboutContent}
                  </p>
                  <div ref={iconsRef}>
                    <Socialicons bordered />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Suspense>
    </Layout>
  );
}

export default Home;
